module.exports = __webpack_public_path__ + "img/icons-2.12817c1f.png";